// src/components/Minihome/widgets/TitleShowcaseWidget.jsx

import { useEffect, useState } from "react";
import { Box, Typography, Stack, CircularProgress, Alert } from "@mui/material";
import { getUserTitles } from "../../../api/titles";
import TitleBadge from "../TitleBadge"; // 1단계에서 수정한 TitleBadge 컴포넌트

export default function TitleShowcaseWidget({ item, username }) {
    const [titles, setTitles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const config = item?.showcaseConfig || {};
    const header = config.header ?? "나의 칭호 목록";
    const layoutMode = config.layoutMode || "grid";
    const backgroundColor = item?.backgroundColor || 'rgba(255,255,255,0.8)';
    const selectedIds = config.selectedIds || [];

    // ✅ 1. showcaseConfig에서 뱃지 색상 값을 가져옵니다.
    const badgeBgColor = config.badgeBackgroundColor;
    const badgeTextColor = config.badgeTextColor;

    useEffect(() => {
        // username이 없으면 API를 호출하지 않도록 방어 코드를 추가하는 것이 좋습니다.
        if (!username) return;

        (async () => {
            setLoading(true); setError("");
            try {
                // 1. getMyTitles() -> getUserTitles(username) 으로 변경
                const titlesArray = await getUserTitles(username);
                setTitles(titlesArray);
            } catch (err) {
                console.error("칭호 진열장 위젯 오류:", err);
                setError("칭호 목록을 불러오지 못했습니다.");
            } finally { setLoading(false); }
        })();
        // 2. 의존성 배열에 [username] 추가
    }, [username]);

    const renderContent = () => {
        if (loading) return <CircularProgress size={24} />;
        if (error) return <Alert severity="warning" sx={{ m: 1 }}>{error}</Alert>;

        const displayedTitles = selectedIds
            .map(id => titles.find(t => t.id === id))
            .filter(Boolean);

        if (displayedTitles.length === 0) {
            return <Typography variant="body2" color="text.secondary">표시할 칭호가 선택되지 않았습니다.</Typography>;
        }

        if (layoutMode === 'list') {
            return (
                <Stack spacing={1} sx={{ alignItems: 'center' }}>
                    {displayedTitles.map(title => (
                        // ✅ 3. 리스트 모드에도 색상 props를 전달합니다.
                        <TitleBadge
                            key={title.id}
                            text={title.name}
                            style={title.style}
                            variant="pill"
                            backgroundColor={badgeBgColor}
                            textColor={badgeTextColor}
                        />
                    ))}
                </Stack>
            );
        }

        return (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
                {displayedTitles.map(title => (
                    // ✅ 3. 격자 모드에도 색상 props를 전달합니다.
                    <TitleBadge
                        key={title.id}
                        text={title.name}
                        style={title.style}
                        variant="pill"
                        backgroundColor={badgeBgColor}
                        textColor={badgeTextColor}
                    />
                ))}
            </Box>
        );
    };

    return (
        <Box sx={{ p: 2, height: '100%', backgroundColor: backgroundColor, display: 'flex', flexDirection: 'column' }}>
            {header && (
                <Typography variant="h6" sx={{ mb: 1.5, flexShrink: 0 }}>
                    {header}
                </Typography>
            )}
            <Box sx={{ flex: 1, overflowY: 'auto' }}>
                {renderContent()}
            </Box>
        </Box>
    );
}